import { Component, OnInit, ErrorHandler, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Devolution, DevolutionItems } from '../shared/devolution';
import { Location } from '@angular/common';
import { MessageService } from '../../../../core/services/message.service';
import { ApiService } from '../../../../core/services/api.service';
import { ComboDto } from '../../../../dtos/combo-dto';
import { Customer } from '../../../customers/shared/customer';
import { OpenStreetMapService } from 'src/app/components/map/services/open-street-map.service';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';

@Component({
  selector: 'app-devolution-add',
  templateUrl: './devolution-add.component.html',
  styleUrls: ['./devolution-add.component.css']
})
export class DevolutionAddComponent implements OnInit {
  vehicleList: ComboDto[] = [];
  vehicle: ComboDto = null;
  form: FormGroup;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  materials: DevolutionItems[] = [
  ];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  submitted: boolean;
  @ViewChild('chipList') chipList;
  @ViewChild("addressControl") addressControl: AddressControlComponent;
  plants: ComboDto[] = [];
  warehouses: ComboDto[] = [];

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private messageService: MessageService,
    private location: Location, private openStreetMapService: OpenStreetMapService) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      vehicleId: [null, Validators.required],
      guide: [null, Validators.required],
      plant: [null, Validators.required],
      warehouse: [null, Validators.required],
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      secondLastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      telephone: ['', [Validators.required]]
    });

    this.getPlants();
    this.getTrucks();

    this.form.get("plant").valueChanges.subscribe(() => {
      setTimeout(() => {
        this.getWarehouses();
      }, 100);
    });
  }

  // convenience getter for easy access to form fields
  get controls() {
    return this.form.controls;
  }

  getTrucks() {
    this.apiService.get<ComboDto[]>('api/vehicle/getVehicleCombo').subscribe((response: ComboDto[]) => {
      if (response) {
        this.vehicleList = this.vehicleList.concat(response);
      }
    });
  }

  getPlants() {
    this.apiService.get('api/plant/combo').subscribe(response => {
      this.plants = response;
    });
  }

  getWarehouses() {
    this.apiService.get('api/warehouse/comboByPlant/' + this.form.value.plant).subscribe(response => {
      this.warehouses = response;
    });
  }

  onSearch() {

  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;


    let isInList: boolean = false;
    let index: number = 0;
    for (let i = 0; i < this.materials.length; i++) {
      if (this.materials[i].material == value.trim()) {
        index = i;
        isInList = true;
      }
    }
    if (isInList) {
      //Increment units
      this.materials[index].units++;
    }
    else {
      // Add our fruit
      if ((value || '').trim()) {
        this.materials.push({ material: value.trim(), units: 1 });
      }
    }

    this.checkChipListErrors();
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(material: any): void {
    const index = this.materials.indexOf(material);

    if (index >= 0) {
      this.materials.splice(index, 1);
    }

    this.checkChipListErrors();
  }

  checkChipListErrors() {
    if (this.materials.length == 0)
      this.chipList.errorState = true;
    else
      this.chipList.errorState = false;
  }

  onSubmit() {
    this.submitted = true;

    this.checkChipListErrors();
    let addressControlData = this.addressControl.getAddressData();

    if (this.form.invalid || this.materials.length == 0 || addressControlData.isInvalid) {
      return;
    }

    let customer: Customer = this.form.value as Customer;
    let address: Customer = addressControlData.values as Customer;

    let model = Object.assign({}, customer, address);

    let devolution: Devolution = {
      vehicleId: this.form.value.vehicleId,
      guide: this.form.value.guide,
      plant: this.form.value.plant,
      warehouse: this.form.value.warehouse,
      client: model,
      items: this.materials
    };

    this.apiService.post("api/ship/devolution", devolution).subscribe(response => {
      this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
        {
          article: 'GENERAL.MESSAGE.THE_2',
          function: 'DEVOLUTIONS.SINGLE',
          action: 'GENERAL.MESSAGE.ACTIONS.ACTION_ADD'
        });

      this.back();
    }, error => {
      this.messageService.handleError(error);
    });

  }

  back() {
    this.location.back();
  }

  resetForm() {
    this.form.reset();
    this.submitted = false;
  }

}
